/**
 * F19b — Client identity-fingerprint helper.
 *
 * Computes sha256(identityPub || signingPub || spkPub) as a 64-char
 * lowercase hex string using SubtleCrypto. Mirrors the server-side
 * implementation in packages/api/src/lib/idk-fingerprint.ts.
 *
 * Sent on every /auth/refresh; the server compares against its cached
 * devices.idk_fingerprint and rejects with 401 idk_fingerprint_mismatch
 * if the local key material has drifted from the published bundle.
 */

function bytesToHex(bytes: Uint8Array): string {
  let hex = "";
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i]!.toString(16).padStart(2, "0");
  }
  return hex;
}

export async function computeIdkFingerprint(
  identityPub: Uint8Array,
  signingPub: Uint8Array,
  spkPub: Uint8Array,
): Promise<string> {
  const total = identityPub.length + signingPub.length + spkPub.length;
  const concat = new Uint8Array(total);
  concat.set(identityPub, 0);
  concat.set(signingPub, identityPub.length);
  concat.set(spkPub, identityPub.length + signingPub.length);
  const digest = await crypto.subtle.digest("SHA-256", concat);
  return bytesToHex(new Uint8Array(digest));
}
